export const mixinCard = {
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      item: {}
    }
  },
  watch: {
    '$props.data': {
      handler(val) {
        this.item = val
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    goDetail(obj) {
      const { compName, address } = this.$route.query
      let path = '/home/noticeInfo'
      let query = { id: obj.id, fromSpecial: true, address, compName }
      if (obj.disposalCode === '2') {
        path = '/home/noticeSealInfo'
      }
      if (this.$route.name === 'searchDetail') {
        delete query.fromSpecial
      }
      let routerJump = this.$router.resolve({
        path: path,
        query: query
      })
      window.open(routerJump.href, '_blank')
    },
    getList() {
      this.$emit('getNoticeList')
    }
  }
}
